export const DOC_CONVERSION_FAILURE = 'DOC_CONVERSION_FAILURE';
export const PRODUCT_KEY_MISSING = 'PRODUCT_KEY_MISSING';
export const REORDER_NOT_PERMITTED = 'REORDER_NOT_PERMITTED';
export const RETIRED_PRODUCT = 'RETIRED_PRODUCT';
export const IS_REORDERABLE_FALSE = 'IS_REORDERABLE_FALSE';

/* list of statuses from the reorder response which will trigger the "This product is not available" feedback banner */
const reorderUnavailableFailureReasons = [
  PRODUCT_KEY_MISSING,
  REORDER_NOT_PERMITTED,
  RETIRED_PRODUCT,
  IS_REORDERABLE_FALSE,
];

export const isDocumentConversionFailure = reorderResponse =>
  reorderResponse?.results?.some(
    result =>
      result.successful === false &&
      result.failureReason === DOC_CONVERSION_FAILURE
  ) || false;

export const isProductUnavailableForReorder = reorderResponse =>
  reorderResponse?.results?.some(
    result =>
      result.successful === false &&
      reorderUnavailableFailureReasons.includes(result.failureReason)
  ) || false;
